/**
 * @generated SignedSource<<207036935521d7c46b9e0ca48f595758>>
 * @relayHash 6d6ccc54e36be8eba0709d2fcb23866b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8a3eb0c0f0c69ab819b82d8c6c8fc301b02ca181aee3201b1156abd8540962ad

import type { ConcreteRequest, Mutation } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TownsquareProjectsAddJiraWorkItemLinkInput = {
  projectId: string;
  replace?: boolean | null | undefined;
  workItemId: string;
};
export type atlasProject_issueFieldAtlasProject_AtlasProjectField_LinkProjectToWorkItemMutation$variables = {
  input: TownsquareProjectsAddJiraWorkItemLinkInput;
};
export type atlasProject_issueFieldAtlasProject_AtlasProjectField_LinkProjectToWorkItemMutation$data = {
  readonly projects_addJiraWorkItemLink: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly __typename: string;
        readonly canReplace?: boolean | null | undefined;
        readonly errorType: string | null | undefined;
        readonly project?: {
          readonly id: string;
          readonly name: string;
        } | null | undefined;
        readonly statusCode: number | null | undefined;
      } | null | undefined;
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
    readonly workItem: {
      readonly fields: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly " $fragmentSpreads": FragmentRefs<"atlasProject_issueFieldAtlasProjectInlineEditFull_AtlasProjectInlineEditViewWithIsEditable_fragmentRef">;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type atlasProject_issueFieldAtlasProject_AtlasProjectField_LinkProjectToWorkItemMutation = {
  response: atlasProject_issueFieldAtlasProject_AtlasProjectField_LinkProjectToWorkItemMutation$data;
  variables: atlasProject_issueFieldAtlasProject_AtlasProjectField_LinkProjectToWorkItemMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "message"
},
v4 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v5 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v6 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = {
  "kind": "ScalarField",
  "name": "name"
},
v9 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "canReplace"
    },
    {
      "concreteType": "TownsquareProject",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v7/*: any*/),
        (v8/*: any*/)
      ]
    }
  ],
  "type": "TownsquareProjectsWorkItemAlreadyLinkedMutationErrorExtension"
},
v10 = [
  (v7/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "atlasProject_issueFieldAtlasProject_AtlasProjectField_LinkProjectToWorkItemMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TownsquareProjectsAddJiraWorkItemLinkPayload",
        "kind": "LinkedField",
        "name": "projects_addJiraWorkItemLink",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v9/*: any*/)
                ]
              }
            ]
          },
          {
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "workItem",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "concreteType": "JiraIssueFieldConnection",
                "kind": "LinkedField",
                "name": "fields",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraIssueFieldEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "FragmentSpread",
                                "name": "atlasProject_issueFieldAtlasProjectInlineEditFull_AtlasProjectInlineEditViewWithIsEditable_fragmentRef"
                              }
                            ],
                            "type": "JiraTownsquareProjectField"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "atlasProject_issueFieldAtlasProject_AtlasProjectField_LinkProjectToWorkItemMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TownsquareProjectsAddJiraWorkItemLinkPayload",
        "kind": "LinkedField",
        "name": "projects_addJiraWorkItemLink",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v9/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": (v10/*: any*/),
                    "type": "BulkMutationErrorExtension"
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "workItem",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "concreteType": "JiraIssueFieldConnection",
                "kind": "LinkedField",
                "name": "fields",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraIssueFieldEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v7/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v8/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "type"
                              },
                              {
                                "concreteType": "JiraIssue",
                                "kind": "LinkedField",
                                "name": "issue",
                                "plural": false,
                                "selections": (v10/*: any*/)
                              },
                              {
                                "concreteType": "JiraTownsquareProject",
                                "kind": "LinkedField",
                                "name": "project",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  {
                                    "alias": "atlasProjectName",
                                    "kind": "ScalarField",
                                    "name": "name"
                                  },
                                  {
                                    "alias": "atlasProjectKey",
                                    "kind": "ScalarField",
                                    "name": "key"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "privateProject"
                                  }
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "isLinkEditable"
                              }
                            ],
                            "type": "JiraTownsquareProjectField"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "8a3eb0c0f0c69ab819b82d8c6c8fc301b02ca181aee3201b1156abd8540962ad",
    "metadata": {},
    "name": "atlasProject_issueFieldAtlasProject_AtlasProjectField_LinkProjectToWorkItemMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "accf172ffc77a233a8b8f34fa3bfd739";

export default node;
